export class VultrInstance {
    public id: string;
    public os: string;
    public ram: number;
    public disk: number;
    public mainIp: string;
    public region: string;
    public status: string;
    public powerStatus: string;
    public serverStatus: string;
    public label: string;
    public kvm: string;


    constructor(id: string, os: string, ram: number, disk: number, mainIp: string, region: string, status: string, powerStatus: string, serverStatus: string, label: string, kvm: string) {
        this.id = id;
        this.os = os;
        this.ram = ram;
        this.disk = disk;
        this.mainIp = mainIp;
        this.region = region;
        this.status = status;
        this.powerStatus = powerStatus;
        this.serverStatus = serverStatus;
        this.label = label;
        this.kvm = kvm;
    }
}